module.exports = __webpack_public_path__ + "img/terassenbau.21444aa2.svg";